export const ACTIONS = {
  SHOW_TOAST_MESSAGE: 'SHOW_TOAST_MESSAGE',
  HIDE_TOAST_MESSAGE: 'HIDE_TOAST_MESSAGE',
};

export const showToast = (message, ctaList, timeout) => dispatch => {
  dispatch({
    type: ACTIONS.SHOW_TOAST_MESSAGE,
    payload: {
      message,
      ctaList,
      timeout,
    },
  });
};

export const hideToast = () => dispatch => {
  dispatch({
    type: ACTIONS.HIDE_TOAST_MESSAGE,
  });
};
